module.exports = __webpack_public_path__ + "img/pr-1.c7687685.png";